export const BookList = {
    book_1: "book1",
};
